import {getPointsDetail} from "../../../../../communication_system/axios_apis/axios_apis";
import createGetRequestThunk from "../../redux_functions/create_get_request_thunk";
import {GET_POINTS_DETAIL} from "./points_detail_type";

export const getPointsDetailAsync = createGetRequestThunk(
  GET_POINTS_DETAIL,
  getPointsDetail
);
